import { TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import { Modal } from "@msuite/ui/modal";
import { DataTable, getInitialRowSelectionState } from "@msuite/ui/table";
import { guardArray } from "@msuite/utils/array";
import type { OrderTemplateFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { articlesTableColumns } from "@/components/stock";
import { useArticles } from "@/hooks/use-articles";
import { OrderTemplateFormTableMenu } from "./order-template-form-table-menu";

export function OrderTemplateForm() {
	/** Hooks */
	const { t } = useTranslation();
	const methods = useFormContext<OrderTemplateFormSchema>();
	const { articles, isLoading, refetch, queryKey } = useArticles();

	/** Functions */
	function getInitialRowSelection() {
		const selectedArticleIds = methods.getValues("articleIds");
		return getInitialRowSelectionState(guardArray(selectedArticleIds));
	}

	/** Render */
	return (
		<Modal.TableWrapper>
			<DataTable
				data={articles}
				columns={articlesTableColumns}
				isLoading={isLoading}
				refetch={refetch}
				queryKey={queryKey}
				enableRowSelection
				enableMultiRowSelection
				initialRowSelectionState={getInitialRowSelection()}
				persistenceKey="order-template-form-article-selection-table"
				initialShowGroupingHeader={false}
				menu={<OrderTemplateFormTableMenu />}
				slots={{
					"above-search": () => (
						<TextInput
							control={methods.control}
							name="name"
							isRequired
							label={t("general.name")}
							placeholder={t("placeholders.stock.order_template_name")}
						/>
					),
				}}
				onRowSelectionChange={(state) => {
					const ids = Object.keys(state);
					methods.setValue("articleIds", ids);
				}}
			/>
		</Modal.TableWrapper>
	);
}
